import { AURRICA_APP_CONFIG } from '@aurrica-web/core-data';

function appLoginUrl(baseUrl: string): string {
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  return `${base}/login`;
}

/** Environment-specific freight login URL for landing CTAs. */
export const LANDING_FREIGHT_LOGIN_URL = appLoginUrl(
  AURRICA_APP_CONFIG.freightAppUrl,
);

/** Environment-specific fleet login URL for landing CTAs. */
export const LANDING_FLEET_LOGIN_URL = appLoginUrl(
  AURRICA_APP_CONFIG.fleetAppUrl,
);
